import {defineStore} from "pinia/dist/pinia";

export const useEndpointStore = defineStore('EndpointStore', {
    state() {
        return {
            endpointState: null,
            iaDomain: "ia-forms.esmo.org",
            uaDomain: "ua-forms.esmo.org",
            proDomain: "forms.esmo.org",
            iaBackend: "graphql.eks-uat.aws.esmo.org",
            uaBackend: "graphql.eks-uat.aws.esmo.org",
            proBackend: "graphql.eks-prod.aws.esmo.org",
            redirectUrl: "https://www.esmo.org",
            apiKeyState: null
        }
    },
    getters: {
        endpoint() {
            if (location.hostname === this.proDomain) {
                return "https://" + this.proBackend
            } else if (location.hostname === this.uaDomain) {
                return "https://" + this.uaBackend
            } else if (location.hostname === this.iaDomain) {
                return "https://" + this.iaBackend
            } else if (location.hostname.search("localhost") !== -1) {
                return "http://localhost:50001"
            }
        },
        apiKey() {
            return this.apiKeyState
        },
        environment() {
            if (location.hostname === this.proDomain) {
                return "pro"
            } else if (location.hostname === this.uaDomain) {
                return "ua"
            } else if (location.hostname === this.iaDomain) {
                return "ia"
            } else if (location.hostname.search("localhost") !== -1) {
                return "localhost"
            }
        }
    },
    actions: {
        setEndpoint(endpoint) {
            this.endpointState = endpoint
        },
        setApiKey(apiKey) {
            this.apiKeyState = apiKey
        }
    },
    persist: {
        storage: sessionStorage
    }
})
